module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dykPO"))).then(() => parcelRequire('d0iPb'));